import React from 'react';
import {Checkbox, type CheckboxProps} from '@mui/material';
import {type CellContext, type RowData} from '@tanstack/react-table';
import {useArrowFocusTrapItem} from '@netx/core-components/ArrowFocusTrapNext';
import {stopPropagation} from '@netx/core-next/utils/browser';
import {splitEventHandler} from '@netx/core-next/utils/fn';

export interface CheckboxCellProps<TData extends RowData>
	extends CellContext<TData, any> {
	CheckboxProps?: Partial<CheckboxProps>;
}

export const CheckboxCellPrimative = <Tdata extends RowData>({
	row,
	CheckboxProps,
}: CheckboxCellProps<Tdata>) => {
	const arrowFocusTrapItem = useArrowFocusTrapItem({
		index: row.index,
	});

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
		<div onMouseDown={stopPropagation}>
			<Checkbox
				tabIndex={arrowFocusTrapItem.attributes.tabIndex}
				{...CheckboxProps}
				onBlur={splitEventHandler(
					CheckboxProps?.onBlur,
					arrowFocusTrapItem.actionAttributes.onBlur,
				)}
				onClick={splitEventHandler(CheckboxProps?.onClick, (event) => {
					stopPropagation(event);
					arrowFocusTrapItem.setActive();
				})}
				onFocus={splitEventHandler(
					CheckboxProps?.onFocus,
					arrowFocusTrapItem.actionAttributes.onFocus,
				)}
			/>
		</div>
	);
};

export const CheckboxCell = CheckboxCellPrimative;

export default CheckboxCell;
